import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M18.364 5.636l-12.728 12.728","key":"svg-1"}]]

const IconCancel = createReactComponent('outline', 'cancel', 'Cancel', __iconNode);

export default IconCancel;